export default "__VITE_ASSET__Dv$0WyLK__"